import { MenuLinkSerializer } from "web/types/serializers";

export const SHOPFRONTS_MENU_NAME = "shopfronts";
export const SHOPFRONTS_VIEW_ALL_EVENT_LABEL = "shopfronts_view_all";

export function isShopfrontsMenu(menu: { name?: string }): boolean {
    return menu.name === SHOPFRONTS_MENU_NAME;
}

interface ShopfrontLinkAnalytics {
    label: typeof SHOPFRONTS_MENU_NAME | typeof SHOPFRONTS_VIEW_ALL_EVENT_LABEL;
    customData?: { retailer_network: string };
}

/**
 * Event label and customData for a Shopfronts nav link click. The "View all"
 * link is not a partner, so it gets its own label and carries no
 * retailer_network — otherwise it is indistinguishable from a click on the
 * Shopfronts nav item itself.
 */
export function getShopfrontLinkAnalytics(link: MenuLinkSerializer): ShopfrontLinkAnalytics {
    if (link.event_label === SHOPFRONTS_VIEW_ALL_EVENT_LABEL) {
        return { label: SHOPFRONTS_VIEW_ALL_EVENT_LABEL };
    }

    return {
        label: SHOPFRONTS_MENU_NAME,
        customData: { retailer_network: link.retailer_network ?? "" },
    };
}
